import React, { useEffect, useState } from 'react';
import { ArrowRight, X } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import img41 from '../../../assets/Traininglocation/cpl-sa.JPG';
import img42 from '../../../assets/Traininglocation/type-rating.JPG';
import img43 from '../../../assets/Traininglocation/cpl-hungary.JPG';



// All component styles, including base styles, hover effects, and media queries, are defined here.
const componentStyles = `
  /* Base Styles */
body {\n  background-color: #ffffff;\n}\n.training-locations-section {
  padding: clamp(60px, 10vh, 100px) clamp(20px, 5vw, 80px);
  background: #ffffff !important;
  min-height: 70vh;
  box-sizing: border-box;
  overflow-x: hidden;
}

  .training-locations-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: clamp(24px, 4vw, 40px);
    align-items: center;
    width: 100%;
    margin-bottom: clamp(40px, 6vh, 80px);
  }

  /* Left Column */
  .training-locations-left-column {
    display: flex;
    flex-direction: column;
    gap: clamp(16px, 3vw, 24px);
    padding: 0;
  }
  
  .training-locations-intro-text {
    font-size: clamp(16px, 2.2vw, 18px);
    line-height: 1.7;
    color: #374151;
    margin: 0;
    max-width: 100%;
  }

  /* EXACTLY MATCH BLOG "Explore All" BUTTON */
  .training-locations-cta-button {
    transition: all 0.3s ease-out;
    transform: translateZ(0);
    white-space: nowrap;
    padding: 0.75rem 1.5rem;
    background-color: #000000;
    color: #ffffff;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    border-radius: 9999px;
    z-index: 10;
    border: none;
    cursor: pointer;
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  }
  
  .training-locations-cta-button:hover {
    background-color: #374151;
    transform: scale(1.05) translateY(-0.25rem);
    box-shadow: 0 10px 25px -3px rgb(0 0 0 / 0.1), 0 4px 6px -2px rgb(0 0 0 / 0.05);
  }

  .training-locations-cta-button:active {
    transform: scale(0.95);
  }

  /* Right Column */
  .training-locations-right-column {
    display: flex;
    flex-direction: column;
    gap: clamp(20px, 4vw, 32px);
  }
  
  /* Container for the headline and button */
  .training-locations-header-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: clamp(16px, 2.5vw, 20px);
  }
  
  .training-locations-headline {
    font-size: clamp(28px, 5vw, 44px);
    font-weight: 700;
    line-height: 1.2;
    color: #0284c7;
    margin: 0;
  }
  
  .training-locations-headline-light {
    color: #9CA3AF;
  }
  
  .training-locations-headline-left {
    font-size: clamp(32px, 6vw, 48px);
  }
  
  /* NEW: Style for the sub-headline */
  .training-locations-sub-headline {
    padding: 0;
    margin: 0;
    color: #0284c7;
  }
  /* Cards Grid */
  .training-locations-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: clamp(28px, 5vw, 48px);
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
  }
  
  /* Card Styles - Based on Blog Card */
  .training-locations-card {
    background-color: transparent;
    border-radius: 0;
    overflow: visible;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: auto;
    width: 100%;
    margin: 0 auto;
    transition: all 0.3s ease;
    box-shadow: none;
    border: none;
    cursor: pointer;
    animation: tl-fade-up 520ms ease both;
  }
  
  .training-locations-card-image {
    width: 100%;
    height: 10cm; /* increased height/width since they occupy full column now */
    overflow: hidden;
    border-radius: 0.75rem; /* same as blog */
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05); /* if they meant only for the inner part */
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .training-locations-card:hover .training-locations-card-image {
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -1px rgb(0 0 0 / 0.06);
  }

  .training-locations-card-img {
    width: 100%; 
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .training-locations-card:hover .training-locations-card-img {
    transform: scale(1.05);
  }

  .training-locations-card-number {
    display: none; /* Hidden to match blog cards */
  }
  
  .training-locations-card-text-container {
    padding: 12px 0 0 0; /* Reduced height, no background */
    background-color: transparent;
    border: none;
    box-shadow: none;
    text-align: left;
  }

  .training-locations-card-text {
    font-size: 1.1rem;
    font-weight: 500;
    color: #111827; /* Gray-900 */
    margin: 0;
    line-height: 1.25;
  }

  /* Remove old card positionings */
  .card-number-top-left, .card-number-top-right, .card-number-bottom-left, .card-number-bottom-right { 
    display: none;
  }
  .card-text-top-left, .card-text-top-right, .card-text-bottom-left, .card-text-bottom-right { 
    display: block;
  }

  @keyframes tl-fade-up {
    from { 
      opacity: 0; 
      transform: translateY(10px); 
    }
    to { 
      opacity: 1; 
      transform: translateY(0); 
    }
  }
  
  .training-locations-card:nth-child(1) { animation-delay: 60ms; }
  .training-locations-card:nth-child(2) { animation-delay: 120ms; }
  .training-locations-card:nth-child(3) { animation-delay: 180ms; }

  /* Modal Styles */
  .training-locations-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
    animation: fadeIn 0.3s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .training-locations-modal {
    background: white;
    border-radius: 24px;
    padding: 40px;
    max-width: 600px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
    animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  .training-locations-modal-close {
    position: absolute;
    top: 20px;
    right: 20px;
    background: #f3f4f6;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #6b7280;
  }

  .training-locations-modal-close:hover {
    background: #e5e7eb;
    color: #374151;
    transform: scale(1.1);
  }

  .training-locations-modal-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 2px solid #f3f4f6;
  }

  .training-locations-modal-flag {
    font-size: 48px;
    line-height: 1;
  }

  .training-locations-modal-title {
    font-size: 32px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    line-height: 1.2;
  }

  .training-locations-modal-subtitle {
    font-size: 16px;
    color: #6b7280;
    margin: 4px 0 0 0;
    font-weight: 500;
  }

  .training-locations-modal-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .training-locations-modal-feature {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px 0;
  }

  .training-locations-modal-feature-icon {
    width: 8px;
    height: 8px;
    background: linear-gradient(135deg, #3b82f6, #1d4ed8);
    border-radius: 50%;
    margin-top: 8px;
    flex-shrink: 0;
  }

  .training-locations-modal-feature-text {
    font-size: 16px;
    line-height: 1.6;
    color: #374151;
    margin: 0;
    font-weight: 500;
  }

  /* --- Enhanced Responsive Design Media Queries --- */

  /* Large Desktops (1440px+) */
  @media (min-width: 1440px) {
    body {
  background-color: #ffffff;
}
.training-locations-section {
      padding: clamp(80px, 8vh, 120px) clamp(40px, 5vw, 100px);
    }
    
    .training-locations-container {
      gap: clamp(40px, 5vw, 60px);
      margin-bottom: clamp(60px, 8vh, 100px);
    }
    
    .training-locations-cards-grid {
      gap: clamp(40px, 6vw, 60px);
      grid-template-columns: repeat(3, 1fr);
    }
    
    .training-locations-card {
      min-height: auto; 
    }
  }

  /* Medium Desktops (1200px - 1439px) */
  @media (max-width: 1439px) and (min-width: 1200px) {
    .training-locations-container {
      gap: clamp(32px, 4vw, 48px);
      margin-bottom: clamp(50px, 7vh, 80px);
    }
    
    .training-locations-cards-grid {
      gap: clamp(32px, 5vw, 48px);
      grid-template-columns: repeat(3, 1fr);
    }
  }

  /* Small Desktops/Large Tablets (1025px - 1199px) */
  @media (max-width: 1199px) and (min-width: 1025px) {
    .training-locations-container {
      grid-template-columns: 1fr;
      gap: clamp(30px, 5vw, 40px);
      margin-bottom: clamp(40px, 6vh, 60px);
    }
    
    .training-locations-header-container {
      justify-content: flex-start;
    }
    
    .training-locations-cards-grid {
      grid-template-columns: repeat(3, 1fr);
      gap: clamp(28px, 4vw, 40px);
    }
    
    .training-locations-card {
      min-height: auto;
      padding: 0;
    }
    
    .training-locations-card-image {
      height: 8cm;
    }
  }

  /* Tablets (769px - 1024px) */
  @media (max-width: 1024px) and (min-width: 769px) {
    body {
  background-color: #ffffff;
}
.training-locations-section {
      padding: clamp(50px, 7vh, 80px) clamp(24px, 4vw, 40px);
    }
    
    .training-locations-container {
      grid-template-columns: 1fr;
      gap: clamp(28px, 4vw, 36px);
      margin-bottom: clamp(40px, 6vh, 60px);
    }
    
    .training-locations-header-container {
      justify-content: flex-start;
    }
    
    .training-locations-cards-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: clamp(24px, 4vw, 36px);
    }
    
    .training-locations-card {
      min-height: auto;
      padding: 0;
    }
    
    .training-locations-card-image {
      height: 8cm;
    }
  }

  /* --- MOBILE VIEW (BELOW 768px) --- */
  @media (max-width: 768px) {
    body {
  background-color: #ffffff;
}
.training-locations-section {
      padding: clamp(40px, 8vh, 60px) clamp(20px, 5vw, 30px);
    }
    
    .training-locations-container {
      display: flex;
      flex-direction: column;
      gap: clamp(24px, 5vh, 36px);
      margin-bottom: clamp(40px, 6vh, 60px);
    }

    .training-locations-left-column {
      align-items: flex-start;
      text-align: left;
      width: 100%;
    }
    
    .training-locations-headline {
      font-size: clamp(28px, 7vw, 36px);
    }
    
    .training-locations-sub-headline {
      padding: 0;
    }

    .training-locations-right-column {
      width: 100%;
    }

    .training-locations-header-container {
      justify-content: center;
      width: 100%;
    }

    /* Override mobile override on the button so it matches blog exact sizes */
    .training-locations-cta-button {
      width: auto;
      justify-content: center;
      padding: 0.75rem 1.5rem;
      font-size: 0.875rem;
      gap: 0;
    }
    
    .training-locations-cards-grid {
      grid-template-columns: 1fr;
      gap: clamp(24px, 6vh, 36px);
      width: 100%;
      padding: 0;
    }

    .training-locations-card {
      width: 100%;
      min-height: auto;
      padding: 0;
      aspect-ratio: unset;
    }

    .training-locations-card-image {
      width: 100%;
      height: 10cm; /* Keeping prominent on mobile */
    }

    .training-locations-card-img {
      width: 100%;
      height: 100%;
      border-radius: 0;
    }

    .training-locations-card-number {
      width: clamp(44px, 10vw, 52px);
      height: clamp(44px, 10vw, 52px);
      font-size: clamp(15px, 3.5vw, 18px);
    }

    .training-locations-card-text {
      font-size: clamp(16px, 4vw, 20px);
      max-width: 100%;
    }

    /* Mobile Modal Styles - Optimized for perfect mobile experience */
    .training-locations-modal-overlay {
      padding: 16px;
      align-items: center;
      justify-content: center;
    }

    .training-locations-modal {
      width: calc(100vw - 32px);
      max-width: none;
      margin: 0;
      padding: 28px 20px 32px 20px;
      border-radius: 20px;
      max-height: calc(100vh - 60px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    }

    .training-locations-modal-close {
      top: 16px;
      right: 16px;
      width: 36px;
      height: 36px;
    }

    .training-locations-modal-header {
      margin-bottom: 24px;
      padding-bottom: 20px;
      gap: 12px;
    }

    .training-locations-modal-flag {
      font-size: 36px;
    }

    .training-locations-modal-title {
      font-size: 26px;
      line-height: 1.1;
    }

    .training-locations-modal-subtitle {
      font-size: 15px;
      margin-top: 2px;
    }

    .training-locations-modal-content {
      gap: 16px;
    }

    .training-locations-modal-feature {
      padding: 12px 0;
      gap: 14px;
    }

    .training-locations-modal-feature-icon {
      width: 6px;
      height: 6px;
      margin-top: 6px;
    }

    .training-locations-modal-feature-text {
      font-size: 15px;
      line-height: 1.5;
      font-weight: 400;
    }
  }

  /* Small Mobile Devices */
  @media (max-width: 480px) {
    body {
  background-color: #ffffff;
}
.training-locations-section {
      padding: clamp(30px, 6vh, 40px) clamp(16px, 4vw, 20px);
    }
    
    .training-locations-cards-grid {
      gap: clamp(20px, 5vh, 28px);
    }
    
    .training-locations-card {
      min-height: auto;
      padding: 0;
    }

    .training-locations-card-image {
      height: 8cm;
    }
    
    .training-locations-card-img {
      width: 100%;
      height: 100%;
    }
  }
`;

const TrainingLocations = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);
const navigate = useNavigate();

  // Array of feature card data
  const featureCards = [
  {
    id: 1,
    number: "01",
    title: "South Africa 🇿🇦",
    imageUrl: img41,
    cornerPosition: { number: "top-left", text: "bottom-left" }
  },
    {
      id: 2,
      number: "02",
      title: "Hungary 🇭🇺",
    imageUrl: img42,      cornerPosition: { text: "top-left", number: "bottom-left" }
    },
    {
      id: 3,
      number: "03",
      title: "India 🇮🇳",
    imageUrl: img43,
          cornerPosition: { number: "top-right", text: "bottom-right" }
    }
  ];

  // Modal content data
  const locationData = {
    1: {
      country: "South Africa",
      flag: "🇿🇦",
      features: [
        "300+ flying days per year, clear weather conditions",
        "Globally recognized licenses & fast training timelines",
        "Affordable, high-quality flight training environment"
      ]
    },
    2: {
      country: "Hungary",
      flag: "🇭🇺",
      features: [
        "European-standard aviation training under EASA framework",
        "Opportunity to train & live in the EU",
        "Access to PharmaFlight's advanced simulators & aviation technology"
      ]
    },
    3: {
      country: "India",
      flag: "🇮🇳",
      subtitle: "Ground Training & Preparations",
      features: [
        "Pre-training guidance and ground classes for aspiring pilots before departure",
        "Local counselling and support with documentation, personality development classes, visas, and airline preparation"
      ]
    }
  };

  // This useEffect hook injects the styles into the document's head
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.textContent = componentStyles;
    document.head.appendChild(styleElement);
    
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  // Modal functions
  const openModal = (card) => {
    setSelectedLocation(locationData[card.id]);
  };

  const closeModal = () => {
    setSelectedLocation(null);
  };

  // Handle escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };

    if (selectedLocation) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [selectedLocation]);

  return (
    <section className="training-locations-section">
      <div className="training-locations-container">
        {/* Left Column - Intro and CTA */}
        <div className="training-locations-left-column">
          <h1 className="training-locations-headline training-locations-sub-headline">
            Where You Can Train
          </h1>
        </div>

        {/* Right Column - Button */}
        <div className="training-locations-right-column">
          {/* Container now only holds the button, and CSS is adjusted to align it right */}
          <div className="training-locations-header-container">
<button 
  className="px-6 py-3 bg-black text-white text-sm font-medium rounded-full z-10 hover:bg-gray-800 transition-transform hover:-translate-y-1 hover:shadow-lg active:scale-95"
  onClick={() => navigate("/contactus")}
>
  Let's Talk
</button>
          </div>
        </div>
      </div>
      
      {/* The cards grid is now outside the two-column layout and has more top margin */}
      <div className="training-locations-cards-grid">
        {featureCards.map((card) => (
          <div 
            key={card.id} 
            className="training-locations-card group"
            onClick={() => openModal(card)}
          >
            <div className="training-locations-card-image">
              <img 
                src={card.imageUrl} 
                alt={`Feature ${card.number}`}
                className="training-locations-card-img group-hover:scale-105"
              />
            </div>
            
            <div className="training-locations-card-text-container">
              <h2 className="training-locations-card-text">
                {card.title}
              </h2>
            </div>
          </div>
        ))}
      </div>
      
      {/* Modal */}
      {selectedLocation && (
        <div 
          className="training-locations-modal-overlay"
          onClick={closeModal}
        >
          <div 
            className="training-locations-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="training-locations-modal-close"
              onClick={closeModal}
              aria-label="Close modal"
            >
              <X size={20} />
            </button>
            
            <div className="training-locations-modal-header">
              <span className="training-locations-modal-flag">
                {selectedLocation.flag}
              </span>
              <div>
                <h2 className="training-locations-modal-title">
                  {selectedLocation.country}
                </h2>
                {selectedLocation.subtitle && (
                  <p className="training-locations-modal-subtitle">
                    {selectedLocation.subtitle}
                  </p>
                )}
              </div>
            </div>
            
            <div className="training-locations-modal-content">
              {selectedLocation.features.map((feature, index) => (
                <div key={index} className="training-locations-modal-feature">
                  <div className="training-locations-modal-feature-icon"></div>
                  <p className="training-locations-modal-feature-text">
                    {feature}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TrainingLocations;
